import { useMemo } from "react";
import { useLCID } from "../../../locale";
import {
  isMeasureItemDTO,
  isFieldItemDTO,
  useDimensionItemsQuery,
  useDimensionssQuery,
  useSavedExportSettingsQuery,
} from "../../api";
import { useBulkExportContext } from "../../providers";
import { virtualConfiguration } from "../BulkExportStepper";
import { BulkExportFormatEnum } from "../../api/mutations/saveBulkExportState/saveBulkExportState.types";
import { useSaveExistBulkExportStateMutation } from "../../api/mutations/saveExistBulkExportState";
import { virtualFrequency } from "../BulkExportStepper/BulkExportStepper.constants";

export function useSaveSettingsButton() {
  const context = useBulkExportContext();
  const lcid = useLCID();

  const state = context?.state;
  const { dataSourceId, savedExportSettingsId } = state ?? {};

  const configuration = state?.dimensions.find((d) => d.id === virtualConfiguration.hierarchyIdentifier);

  const { isSavedExportSettingsLoading, savedExportSettings, refetchSavedExportSettings } = useSavedExportSettingsQuery();
  const { isDimensionsLoading, dimensions } = useDimensionssQuery(state?.dataSourceId);
  const { dimensionItems: configurationItems } = useDimensionItemsQuery(lcid, dataSourceId, virtualConfiguration.identifier);

  const { saveExistBulkExportState, isSaveExistBulkExportStateSuccess } = useSaveExistBulkExportStateMutation();

  return useMemo(() => {
    const selectedMeasures = configurationItems?.filter(isMeasureItemDTO).filter((it) => configuration?.selection.includes(it.id));
    const selectedFields = configurationItems?.filter(isFieldItemDTO).filter((it) => configuration?.selection.includes(it.id));
    const saveExistExportSettings = () => {
      const savedExportSetting = savedExportSettings!.find((d) => d.id === savedExportSettingsId)!;
      const cubeId = savedExportSetting.cubeId;
      const name = savedExportSetting.name;
      const finalDimension = state!.dimensions
        .filter((d) => d.id !== virtualConfiguration.hierarchyIdentifier)
        .map((dimension) => {
          const dimensionId = dimension.id;
          const fieldNameItem = selectedFields?.find((field) => field.id.toString().includes(dimensionId));
          const fieldName = fieldNameItem?.name ?? "";
          return {
            ...dimension,
            fieldName,
            isSelected: !!fieldName,
          };
        });

      const finalMeasures = selectedMeasures!.map((measure) => ({
        fieldName: measure.name,
        id: measure.id as string,
        isSelected: true,
      }));
      
      configuration?.selection.forEach((el) => {
        if (!finalDimension.find((dim) => `${el}`.includes(dim.id))) {
          finalDimension.push({
            selection: [],
            isSelected: true,
            fieldName: configurationItems?.find((field) => field.id.toString() === el)?.name || "",
            id: `${el}`.replace(".name", ""),
          });
        }
      });
      const format = BulkExportFormatEnum[state!.format];

      saveExistBulkExportState({
        id: state!.savedExportSettingsId!,
        data: {
          format,
          cubeId,
          name,
          dimensions: finalDimension
          .filter((dim) => dim.id !== virtualConfiguration.identifier)
          .filter((dim) => dim.id !== virtualFrequency.hierarchyIdentifier)
          .filter((dim) => dim.id !== "value")
          .filter((dim) => dim.id !== "source")
          .filter((dim) => dim.id !== "value_trade"),
          measures: finalMeasures,
        },
      });

      setTimeout(() => {
        refetchSavedExportSettings();
      }, 2000);
    };
    return { saveExistExportSettings };
  }, [
    saveExistBulkExportState,
    state,
    isDimensionsLoading,
    dimensions,
    configuration,
    configurationItems,
    isSavedExportSettingsLoading,
    savedExportSettings,
    state?.format,
    state?.savedExportSettingsId,
  ]);
}
